module.exports = "/_next/static/images/e2e458202712dd04edae0ec55b8d25a0-man-looking-up-smiling-md@2x.jpg.webp";